import React, { useMemo } from 'react';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { convertiUtsToDate } from '../GrapheXT/GrapheXT';

const TableauTelt = ({
  configuration,
  donnees,
  viewobj_json_content,
  switchAfficherModifierIntervalle,
  dimensionWidth,
  dimensionHeight,
  donneesGraphe,
}) => {
  const tableData = useMemo(() => {
    // Vérification des données requises
    if (!configuration || !donnees) {
      return { data: [], layout: {} };
    }

    // Configuration de la mise en page du tableau
    const layout = {
      font: { size: 14 },
      title: {
        text: configuration.title + '<br>' + configuration.subtitle,
        font: { color: '#3c3935' },
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        x: 0,
        y: -0.0,
      },
      ...(viewobj_json_content?.layout || {}),
    };

    // Préparation des lignes du tableau
    let tableRows = [];

    // Parcourir toutes les courbes de données
    for (let curve of donnees) {
      // Trouver l'index de la valeur maximale
      const maxIndex = curve.y.indexOf(Math.max(...curve.y));
      const minIndex = curve.y.indexOf(Math.min(...curve.y));
      const maxValue = curve.y[maxIndex];
      const minValue = curve.y[minIndex];
      const maxValueDate = curve.x[maxIndex];
      const minValueDate = curve.x[minIndex];

      // Récupérer la dernière valeur et sa date
      const latestValue = curve.y[curve.y.length - 1];
      const latestValueDate = curve.x[curve.x.length - 1];

      // Créer une ligne avec: nom, dernière valeur, date dernière valeur, valeur max, date max
      let newRow = [
        curve.name,
        latestValue,
        convertiUtsToDate([latestValueDate]),
        minValue,
        convertiUtsToDate([minValueDate]),
        maxValue,
        convertiUtsToDate([maxValueDate])
      ];

      tableRows.push(newRow);
    }

    // Déterminer l'unité d'ingénierie à partir de la première courbe
    const engineeringUnit =
      donnees.length > 0 ? donnees[0].engineering_unit : '';

    // Définir les en-têtes du tableau
    const tableHeaders = [
      'Capteur',
      `Dernière valeur [${engineeringUnit}]`,
      'Date dernière valeur',
      `Valeur MIN [${engineeringUnit}]`,
      'Date Valeur MIN',
      `Valeur MAX [${engineeringUnit}]`,
      'Date Valeur MAX',
    ];

    // Transposer les lignes en colonnes pour Plotly
    // Plotly nécessite les données organisées par colonnes, pas par lignes
    const transposedData = tableHeaders.map((_, colIndex) =>
      tableRows.map((row) => row[colIndex])
    );

    // Couleur d'en-tête du tableau
    const headerColor = '#EFB805';

    // Configuration finale du tableau Plotly
    const data = [
      {
        type: 'table',
        columnwidth: [3, 3, 3, 3, 3, 3, 3],
        header: {
          values: tableHeaders,
          align: ['left', 'center'],
          line: { width: 1, color: '#000000' },
          fill: { color: headerColor },
          font: { family: 'Arial', size: 17, color: 'white' },
        },
        cells: {
          values: transposedData,
          align: ['left', 'center'],
          line: { color: '#000000' },
          font: { family: 'Arial', size: 17, color: ['#506784'] },
          height: 25,
        },
      },
    ];

    return { data, layout };
  }, [configuration, donnees, viewobj_json_content]);

  return (
    <BibliothequePlotly
      data={tableData.data}
      layout={{
        ...tableData.layout,
        responsive: true,
        ...viewobj_json_content,
      }}
      donneesGraphe={donneesGraphe}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
    />
  );
};

export default TableauTelt;
